import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["portalId", "authenticatorId", "appName", "oAuthScope", "appId", "mcp", "onComplete", "onCancel", "shouldDeleteOnFailure", "introScreen", "successScreen"];
import { useState } from 'react';
import UnifiedAuthModal from './UnifiedAuthModal';
import { deleteSecret } from './Api';
import { useHttpClient } from './HttpClientContext';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const noop = () => {};
export function UnifiedAuthButton(_ref) {
  let {
      portalId,
      authenticatorId,
      appName,
      oAuthScope,
      appId,
      mcp,
      onComplete,
      onCancel = noop,
      shouldDeleteOnFailure,
      introScreen,
      successScreen
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const http = useHttpClient();
  const [showAuthModal, setShowAuthModal] = useState(false);
  function closeModal() {
    setShowAuthModal(false);
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, Object.assign({}, props, {
      onClick: clickEvent => {
        setShowAuthModal(true);
        if (props.onClick) {
          props.onClick(clickEvent);
        }
      }
    })), showAuthModal && /*#__PURE__*/_jsx(UnifiedAuthModal, {
      portalId: portalId,
      authenticatorId: authenticatorId,
      appName: appName,
      oAuthScope: oAuthScope,
      appId: appId,
      mcp: mcp,
      onComplete: secretId => {
        let onCompleteSucceeded = false;
        try {
          onComplete(secretId);
          onCompleteSucceeded = true;
        } catch (error) {
          const shouldCleanup = shouldDeleteOnFailure ? shouldDeleteOnFailure(secretId) : true;
          if (shouldCleanup) {
            // This is intentionally fire and forget.
            void deleteSecret(http, portalId, authenticatorId, secretId);
          }
          throw error;
        } finally {
          // Auto-close modal only if no custom success screen is provided
          if (onCompleteSucceeded && !successScreen) {
            closeModal();
          }
        }
      },
      onCancel: () => {
        closeModal();
        onCancel();
      },
      introScreen: introScreen,
      successScreen: successScreen
    })]
  });
}
export default UnifiedAuthButton;